export default __webpack_public_path__ + "static/media/RobotoCondensed-Regular.fc3d2f2e.ttf";